export const apiCreate = (): string => '/commercial/phasesProcess/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/phasesProcess/' : `/commercial/phasesProcess/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/phasesProcess/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/phasesProcess/${id}`
